<ld-base-modal
  [title]="''"
  size="medium"
  [showCloseButton]="true"
  [closeOnBackdropClick]="false"
  (closeModal)="onClose()"
>
  <ng-container modal-content>
    <div id="satisfaction-survey-content" class="px-2 py-4 text-center" *transloco="let t">
      @if (currentStep() === 1) {
        <div id="satisfaction-step-1" class="space-y-6">
          <div
            id="satisfaction-step-1-icon"
            class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-ld-primary-50 text-4xl"
          >
            😊
          </div>
          <h2 id="satisfaction-step-1-title" class="text-lg font-semibold text-gray-900">
            {{ t('satisfactionSurveyStep1Title') }}
          </h2>
          <p id="satisfaction-step-1-message" class="text-sm text-gray-600">
            {{ t('satisfactionSurveyStep1Message') }}
          </p>
          <div id="satisfaction-step-1-actions" class="flex justify-center gap-3 pt-2">
            <button
              id="satisfaction-step-1-yes"
              type="button"
              class="rounded-lg bg-ld-primary px-8 py-2.5 text-sm font-medium text-white transition-colors hover:bg-ld-primary-700"
              (click)="onHappyYes()"
            >
              {{ t('commonYes') }}
            </button>
            <button
              id="satisfaction-step-1-no"
              type="button"
              class="rounded-lg border border-gray-300 px-8 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
              (click)="onHappyNo()"
            >
              {{ t('commonNo') }}
            </button>
          </div>
        </div>
      }

      @if (currentStep() === 2) {
        <div id="satisfaction-step-2" class="space-y-6">
          <div
            id="satisfaction-step-2-icon"
            class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-4xl"
          >
            💬
          </div>
          <h2 id="satisfaction-step-2-title" class="text-lg font-semibold text-gray-900">
            {{ t('satisfactionSurveyStep2Title') }}
          </h2>
          <p id="satisfaction-step-2-message" class="text-sm text-gray-600">
            {{ t('satisfactionSurveyStep2Message') }}
          </p>
          <div id="satisfaction-step-2-actions" class="flex flex-col gap-2 pt-2">
            <button
              id="satisfaction-step-2-yes"
              type="button"
              class="w-full rounded-lg bg-ld-primary px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-ld-primary-700"
              (click)="onGiveFeedback()"
            >
              {{ t('satisfactionSurveyGiveFeedback') }}
            </button>
            <button
              id="satisfaction-step-2-maybe-later"
              type="button"
              class="w-full rounded-lg border border-gray-300 px-6 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50"
              (click)="onMaybeLater()"
            >
              {{ t('satisfactionSurveyMaybeLater') }}
            </button>
            <button
              id="satisfaction-step-2-no-thanks"
              type="button"
              class="w-full px-6 py-2.5 text-sm font-medium text-gray-500 transition-colors hover:text-gray-700"
              (click)="onNoThanks()"
            >
              {{ t('commonButtonsNoThanks') }}
            </button>
          </div>
        </div>
      }
    </div>
  </ng-container>
</ld-base-modal>
